import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";
import { imagePath } from "../../helpers/constants";
function Banners(props) {
  // RN PromoSection parity: 4s auto-advance with dot pagination
  var settings = {
    dots: props.Banner.length > 1,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    dotsClass: "slick-dots byk-banner-dots",
  };
  const _renderBanner = () => {
    return props.Banner.map((img, i) => {
      return (
        <div className="banner-item w-full h-full flex items-center justify-center max-md:!px-3 max-md:!pb-3 bg-black " key={img?.id}>
          <a href="/promotions" className="block w-full h-full">
            <img
              src={imagePath("banners", img?.banner)}
              className="object-contain w-full h-full"
              alt=""
              style={{
                maxHeight: "300px",
                maxWidth: "100%",
                display: "block",
                margin: "0 auto",
                borderRadius: 12,
              }}
            />
          </a>
        </div>
      );
    });
  };

  // No banners: the design's hatched plate instead of an empty box.
  if (!props.Banner?.length) {
    return (
      <div
        data-testid="banner-placeholder"
        style={{
          width: "100%",
          minHeight: 200,
          display: "grid",
          placeItems: "center",
          padding: 12,
          textAlign: "center",
          background: "var(--surface-2)",
          backgroundImage: "var(--texture-hatch)",
          border: "1px dashed var(--border-default)",
          borderRadius: "var(--radius-md)",
        }}
      >
        <span style={{ font: "var(--type-mono)", fontSize: 11, color: "var(--text-muted)" }}>Promo banner</span>
      </div>
    );
  }

  return (
    <Slider className="menu w-full h-full" {...settings}>
      {_renderBanner()}
    </Slider>
  );
}

export default Banners;
